import { ICurrency } from "./currency.interface";
import { IShop } from "./shop.interface";
import { IStatus } from "./status.interface";

export interface ICreateOrder {
  shop_id: number;
  product_id?: number;
  order_details: ICreateOrderDetails[];
}

export interface ICreateOrderDetails {
  reference_address: string;
  size: string;
  color: string;
  amount: number;
  comment: string;
  files: string[] | File[];
  image_path?: string[];
}

export interface IOrderDetails {
  reference_address: string;
  size: string;
  color: string;
  amount: number;
  comment: string;
  status: IStatus;
  price: string;
  currency: ICurrency;
  currencylast: ICurrency;
  price_eur: string;
  files: string[] | File[];
  image_path?: string[];
}

export interface ILoadOrder {
  client_id: number;
  id: number;
  shop_id: number;
  status_id: number;
  created_at: string;
  delivery_option_id: number;
  order_date: string;
  order_delivery_date: string;
  order_details: IOrderDetails[];
  order_payment_date: string;
  shop: IShop;
  status: IStatus;
  status_datetime: string;
  total_amount_plan: string;
  updated_at: string;
  payment_amount_eur: string;
}

export interface IOrder {
  id: number;
  client_id: number;
  shop_id: number;
  created_at: string;
  shop: IShop;
  status: IStatus;
  order_details: IOrderDetails[];
  price_eur: string;
}